import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const DEMO_EMAIL = "demo@aurorageriatrica.com";
const DEMO_PASSWORD = "Demo1234!";

export default function EntrarDemo() {
  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const autoLogin = async () => {
      try {
        if (isAuthenticated && user?.email === DEMO_EMAIL) {
          navigate("/dashboard", { replace: true });
          return;
        }
        await login(DEMO_EMAIL, DEMO_PASSWORD);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError("No se pudo acceder al demo. Intente de nuevo.");
      }
    };
    autoLogin();
  }, [isAuthenticated, login, navigate, user?.email]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="text-center">
          <p className="text-red-600 text-sm mb-3">{error}</p>
          <a href="/demo-clinico" className="text-sky-600 underline text-sm">
            Volver al demo
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 to-sky-50">
      <div className="text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-sky-200 border-t-sky-600" />
        <p className="text-sm font-medium text-slate-600">Entrando al demo de Aurora...</p>
        <p className="mt-1 text-xs text-slate-400">Preparando tu experiencia</p>
      </div>
    </div>
  );
}
